var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.2004C11.8684 17.2011 11.7379 17.1759 11.6161 17.1261C11.4943 17.0764 11.3834 17.0031 11.29 16.9104L5.29 10.9104C5.19676 10.8171 5.1228 10.7065 5.07234 10.5846C5.02188 10.4628 4.99591 10.3322 4.99591 10.2004C4.99591 9.93408 5.1017 9.67868 5.29 9.49038C5.47831 9.30208 5.7337 9.19629 6 9.19629C6.2663 9.19629 6.5217 9.30208 6.71 9.49038L12 14.7804L17.29 9.49038C17.3832 9.39714 17.4939 9.32318 17.6158 9.27272C17.7376 9.22226 17.8681 9.19629 18 9.19629C18.1319 9.19629 18.2624 9.22226 18.3843 9.27272C18.5061 9.32318 18.6168 9.39714 18.71 9.49038C18.8032 9.58362 18.8772 9.69431 18.9277 9.81613C18.9781 9.93795 19.0041 10.0685 19.0041 10.2004C19.0041 10.3322 18.9781 10.4628 18.9277 10.5846C18.8772 10.7064 18.8032 10.8171 18.71 10.9104L12.71 16.9104C12.6166 17.0031 12.5057 17.0764 12.3839 17.1261C12.2621 17.1759 12.1316 17.2011 12 17.2004Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.64ee8df61ba5f2abc142b681546117bf.svg";
export { ForwardRef as ReactComponent };